import { useMemo } from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { Theme } from '@mui/material/styles';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import CreditCardOutlined from '@mui/icons-material/Person'; // Import an icon for the profile

// project import
import useConfig from 'hooks/useConfig';
import Search from './Search';
import Message from './Message';
import Profile from './Profile';
import Localization from './Localization';
import Notification from './Notification';
import Customization from './Customization';
import MobileSection from './MobileSection';
import MegaMenuSection from './MegaMenuSection';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { i18n } = useConfig();

  const matchesXs = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const localization = useMemo(() => <Localization />, [i18n]);

  const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {!matchesXs && <Search />}
      {/* {!matchesXs && megaMenu} */}
      {/* {!matchesXs && localization} */}
      {matchesXs && <Box sx={{ width: '100%', ml: 1 }} />}

      {/* Add the profile icon with a link */}
      <IconButton component={Link} to="/apps/profiles/user/stripe" color="inherit">
        <CreditCardOutlined />
      </IconButton>

      <Notification />
      {/* <Message /> */}
      <Customization />
      {!matchesXs && <Profile />}
      {matchesXs && <MobileSection />}
    </>
  );
};

export default HeaderContent;
